/**
 * Turn `completedAt` is the latest known end of the turn: assistant messages,
 * interrupts and settle events each push it forward, never back.
 */
export function laterIsoTimestamp(left, right) {
    if (!left)
        return right;
    const leftMs = Date.parse(left);
    const rightMs = Date.parse(right);
    if (Number.isNaN(leftMs) || Number.isNaN(rightMs))
        return right;
    return leftMs > rightMs ? left : right;
}
export function formatDuration(durationMs) {
    if (!Number.isFinite(durationMs) || durationMs < 0)
        return "0ms";
    if (durationMs < 1_000)
        return `${Math.max(1, Math.round(durationMs))}ms`;
    if (durationMs < 10_000)
        return `${(durationMs / 1_000).toFixed(1)}s`;
    if (durationMs < 60_000)
        return `${Math.round(durationMs / 1_000)}s`;
    const minutes = Math.floor(durationMs / 60_000);
    const seconds = Math.round((durationMs % 60_000) / 1_000);
    if (seconds === 0)
        return `${minutes}m`;
    if (seconds === 60)
        return `${minutes + 1}m`;
    return `${minutes}m ${seconds}s`;
}
export function formatElapsed(startIso, endIso) {
    if (!endIso)
        return null;
    const startedAt = Date.parse(startIso);
    const endedAt = Date.parse(endIso);
    if (Number.isNaN(startedAt) || Number.isNaN(endedAt) || endedAt < startedAt) {
        return null;
    }
    return formatDuration(endedAt - startedAt);
}
export function isLatestTurnSettled(latestTurn, session) {
    if (!latestTurn?.startedAt)
        return false;
    if (!latestTurn.completedAt)
        return false;
    if (!session)
        return true;
    if (session.orchestrationStatus === "running")
        return false;
    return true;
}
export function deriveActiveWorkStartedAt(latestTurn, session, sendStartedAt) {
    if (!isLatestTurnSettled(latestTurn, session)) {
        return latestTurn?.startedAt ?? sendStartedAt;
    }
    return sendStartedAt;
}
